<template>
  <div class="demo-page">
    <img src="../assets/logo-wight.png" class="logo-con" />
    <el-input size="medium" :placeholder="formatMessage({id:'5g.message.h5.login.phone.name',defaultMessage:'手机号'})"  v-model="phone" v-on:blur="blurCheck" type="tel"></el-input>
    <div class="errorText" v-if="!isValid && errorLabel">{{errorLabel}}</div>

    <div style="display:flex;margin: 10px 0px;">
      <el-input size="medium" style="display:inline-block;flex:1;" v-model="verifyCodeVerify" type="text">
      </el-input>
      <img v-if="verifyUrl" :src="verifyUrl" style="display:inline-block;height:36px;width:111px;" v-on:click="refreshVerifyCode">
      <span v-else style="border: 1px solid #DCDFE6;display:inline-block;height:36px;width:111px;text-align: center;line-height:36px;" v-on:click="refreshVerifyCode">{{formatMessage({id:'5g.message.h5.login.input.phone',defaultMessage:'请输入手机号'})}}</span>
    </div>

    <el-input size="medium" style="margin: 10px 0px" v-model="smsCode" type="text">
      <template v-if="getSmsInterval" slot="append">{{timer}}s</template>
      <template v-else slot="append"><div style="color: #2b9939" v-on:click="sendSmsCode">{{formatMessage({id:'5g.message.h5.login.getCode',defaultMessage:'获取验证码'})}}</div></template>
    </el-input>
    
   

    <div style="text-align:left; margin-bottom:10px">
      <el-checkbox v-model="agree">
        <a v-on:click="showPrivacyPolicies" style="color: #2b9939">{{formatMessage({id:'5g.message.h5.login.xieyi',defaultMessage:'同意用户隐私政策'})}}</a>
      </el-checkbox>
    </div>
    <el-button class="block-btn" v-on:click="handleLogin">{{formatMessage({id:'5g.message.h5.login',defaultMessage:'登录'})}}</el-button>

    <el-dialog
      :title="formatMessage({id:'5g.message.h5.login.modal.title',defaultMessage:'用户注册及使用APP隐私协议'})"
      :visible.sync="showDialog"
      width="90%" top="16px"
      center>
      <div style="white-space: pre-wrap">{{PolicyText}}</div>
      <div style="text-align: center">南京绛门信息科技股份有限公司</div>
      <span slot="footer" class="dialog-footer">
        <el-button type="warning" @click="showDialog = false" plain>{{formatMessage({id:'5g.message.h5.login.xieyi',defaultMessage:'同意用户隐私政策'})}}</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import { getSmsCode, checkSmsCode,BaseUrl } from '../services'
import { PolicyText } from './policyText.js'
import { encode } from 'js-base64'
import { postUserDeviceInfo } from '../utils'
import moment from 'moment'

export default {
  name: 'Login',
  // 页面级组件的数据模型，影响传入数据的覆盖机制：private内定义的属性不允许被覆盖
  data () {
    return {
      verifyUrl:'',
      serviceNo: undefined, // url参数携带的机器人服务号
      phone: '',
      isValid: true, // 验证号码是否合法
      errorLabel: '',
      smsCode: '',
      verifyCodeVerify:'',
      showLoading: false,
      agree: false,
      showDialog: false,
      PolicyText: PolicyText,

      getSmsInterval: null,
      timer: 60,
    }
  },

  methods: {
    showPrivacyPolicies(){
      this.showDialog = true;
    },
    handleAgree(){
      this.agree = true;
    },
    
    blurCheck(){
      this.checkPhone('blur');
    },
    checkPhone(type){
      const phone = this.phone;
      if(!phone){
        this.isValid = false;
        this.errorLabel = '手机号码不能为空！';
        return false
      } else if (RegExp(/^((13[0-9])|(14[5,7])|(15[0-3,5-9])|(17[0,3,5-8])|(18[0-9])|166|198|199|(147))\d{8}$/).test(phone)){
        this.isValid = true;
        this.errorLabel = '';
        if(type==='blur'){
          this.refreshVerifyCode();
        }
        return true
      } else {
        this.isValid = false;
        this.errorLabel = '手机号码不合法！';
        return false
      }
    },
    refreshVerifyCode(){
      this.verifyCodeVerify='';
      this.verifyUrl = `${BaseUrl}/a2p/api/v1/verify/code/getVerifyCode?tme=${moment().valueOf()}&phone=${this.phone}`
    },
    
    sendSmsCode(){
      const phone = this.phone;
      const valid = this.checkPhone();
      if(valid){
        if(!this.verifyCodeVerify||this.verifyCodeVerify.length!==4){
          return this.$message({
              message: '请输入正确的图形验证码！',
              type: 'error'
            });
        }
        const _this = this;
        _this.timer = 60;
        _this.getSmsInterval = setInterval(()=>{
          if(_this.timer === 1){
            clearInterval(_this.getSmsInterval);
            _this.getSmsInterval = null;
          }
          _this.timer = _this.timer - 1;
        }, 1000)
        getSmsCode({phone,verifyCode:this.verifyCodeVerify}).then(response => {
          if(response && response.success){
            this.refreshVerifyCode();
            _this.$message({
              message: '验证码已发送，请注意查收！',
              type: 'success'
            });
          }
        }).catch(err=>{
          _this.$message({
            message: '验证码发送失败！',
            type: 'error'
          });
        })
      }
    },
    
    handleLogin (){
      const oldMobileNo = localStorage.getItem('mobileNo');
      const phone = this.phone;
      const valid = this.checkPhone();
      if(valid && this.smsCode){
        if(this.agree){
          const params = { phone, smsCode: this.smsCode,verifyCode:this.verifyCodeVerify };
          const _this = this;
          postUserDeviceInfo(phone);
          checkSmsCode(params).then(response => {
            if(response && response.success){
              localStorage.setItem('mobileNo', phone);
              localStorage.setItem('mobileNoLoginStatus', true);
              _this.$message({
                message: '登录成功！',
                type: 'success'
              });

              if(_this.serviceNo){
                const params = JSON.stringify({ 
                  mobileNo: phone, 
                  serviceNo: _this.serviceNo
                })
                localStorage.setItem('urlActionNeedReply', false); // 控制是否正常下发
                _this.$router.push(`/chatRoom?param=${encode(params)}`)
              } else {
                _this.$router.push('/')
              }
            }
          }).catch(err=>{
            _this.$message({
              message: '登录失败！',
              type: 'error'
            });
          })
        } else {
          this.$message({
            message: '请同意用户隐私政策！',
            type: 'warning'
          });
        }
      } else {
        this.$message({
          message: '信息输入不完整！',
          type: 'warning'
        });
      }
    },

    // toChatbotList() {
    //   // 跳转到应用内的某个页面，router用法详见：文档->接口->页面路由
    //   router.push({
    //     uri: '/ChatbotList'
    //   })
    // }
  },

  created(){
    const _this = this;
    const mobileNo = localStorage.getItem('mobileNo');
    console.log('localStorage get mobileno', mobileNo);
    const href = window.location.href;
    const index = href.indexOf('serviceNo=')
    if(index > -1){
      const lastIndex = href.length
      const serviceNo = href.substring(index + 10, lastIndex)
      console.log('serviceNo', serviceNo)
      this.serviceNo = serviceNo;
    }
    
    if(mobileNo){
      this.phone = mobileNo;
      this.refreshVerifyCode();
    }
  },

}
</script>

<style lang="less" scoped>
  .demo-page {
    position: absolute;
    padding: 10px;
    height: calc( 100% - 22px );
    max-width: 392px;
    border: 1px solid #ddd;
    border-bottom: none;
    background-color: #fff;
  }
  .logo-con{
    width: 50%;
    margin: 20px auto;
    border-radius: 20px;
  }
  .errorText{
    color: red;
    font-size: 12px;
    width: 100%;
    text-align: left;
  }
  
  .input-text {
    background-color: #ffffff;
    width: calc( 100% - 22px );
    height: 30px;
    border: 1px solid #aaa;
    line-height: 30px;
    margin-bottom: 10px;
    padding: 3px 10px;
  }
  .input-short{
    width: 50%;
  }
  .primary-btn{
    background-color: dodgerblue;
    width: 100%;
    height: 38px;
    border: none;
  }
  .block-btn{
    width: 100%;
    width: 100%;
    background-color: #2b9939;
    color: #fff;
  }
  .agree-btn{
    color: #2b9939;
    background-color: #fff;
  }
  .el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner{
    background-color: #2b9939 !important;
    border-color: #2b9939 !important;
  }
</style>


// WEBPACK FOOTER //
// src/login/index.vue